import { render, staticRenderFns } from "./Hitswall.vue?vue&type=template&id=aa163212&"
import script from "./Hitswall.vue?vue&type=script&lang=js&"
export * from "./Hitswall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports